import { render } from "./ConfiguracaoInicialEquipe.vue?vue&type=template&id=702bd6d0&scoped=true&ts=true"
import script from "./ConfiguracaoInicialEquipe.vue?vue&type=script&lang=ts"
export * from "./ConfiguracaoInicialEquipe.vue?vue&type=script&lang=ts"

import "./ConfiguracaoInicialEquipe.vue?vue&type=style&index=0&id=702bd6d0&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-702bd6d0"]])

export default __exports__